import template from "./pTermsOfUse.html";
import moment   from "moment";

export function pTermsOfUseDirective() {
  'ngInject';

  let directive = {
    restrict: 'E',
    template: template,
    controller: pTermsOfUseController,
    controllerAs: 'pTermsOfUse',
    bindToController: true
  };

  return directive;
}

class pTermsOfUseController {
  constructor($interval, $scope, Notes, ConnectionQuality, Auth) {
    'ngInject';

    this.Auth = Auth;
    this.ConnectionQuality = ConnectionQuality;
    this.Notes = Notes;
    this.state = 'loading';

    this.init();

    this.timeout = $interval(() => {
      this.notes = Notes.getNotes();
    }, 10);

    $scope.$on("$destroy", () => {
      $interval.cancel( this.timeout );
    });

    $scope.$on('connectionQualityChanged', () => {
      if (this.ConnectionQuality.isSlow) {
        this.Notes.postNote({
          type: 'slowConnection',
          manualHide: true
        });
      }
      else {
        const note = this.Notes.getNotes().find(note => note.type === 'slowConnection' && note.active);
        if (note)
          this.Notes.hide(note);
      }
    });
  }

  init() {
    this.state = 'loading';
    this.Auth.getLatestTermsOfUse().then(
      ({data}) => {
        this.state = 'loaded';
        this.terms = {
          ...data,
          createdAt: moment(data.createdAt).format('DD-MM-YYYY')
        };

        this.contentToDisplay = this.terms.content.english;
        this.version = this.terms.version;
        this.createdAt = this.terms.createdAt;
      },
      error => {
        this.state = error;
        this.contentToDisplay = "ERROR";
      }
    );
  }

  switchLanguage(language) {
    this.language = language;
    this.contentToDisplay = this.terms.content[language];
  }
}
